module.exports = import("https://via.placeholder.com/500");;